import { AlertConditionType } from "@/types/alerts";

/**
 * Format threshold value based on condition type
 */
export const formatThresholdValue = (value: any, conditionType: AlertConditionType): string => {
    // Handle undefined/null values
    if (value === undefined || value === null) {
        return 'N/A';
    }

    // Handle numeric values
    if (typeof value === 'number') {
        return value.toString();
    }

    // Handle array values for range conditions
    if (Array.isArray(value) &&
        (conditionType === 'range' || conditionType === 'between' || conditionType === 'outside')) {
        // Ensure there are at least 2 values
        if (value.length >= 2) {
            return `${value[0]} - ${value[1]}`;
        }
        // If array is incomplete, just join values
        return value.join(', ');
    }

    // Handle object values by converting to JSON string
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }

    // Default case: convert to string
    return String(value);
};
